import React from "react";
import { Box, Slider, Typography } from "@mui/material";

const CustomSliderInput = ({
  label = "",
  name,
  value = 0,
  onChange,
  error,
  helperText,
  min = 0,
  max = 5,
  step = 0.5,
  isLock,
  isReadOnly,
  disabled,
  showMarks = true,
  showColorFeedback = true,
  ...rest
}) => {
  const marks = showMarks
    ? [
        { value: min, label: "Poor" },
        { value: (min + max) / 2, label: "Average" },
        { value: max, label: "Excellent" },
      ]
    : false;

  const getColor = () =>
    !showColorFeedback
      ? "primary"
      : value <= max * 0.3
      ? "error.main"
      : value <= max * 0.6
      ? "warning.main"
      : "success.main";

  const isDisabled = isLock || disabled || isReadOnly;

  return (
    <Box
      sx={{
        width: {
          xs: "90%", 
          sm: "80%", 
          md: "80%",
          lg: "50%",
        },
        mt: 1,
      }}
    >
      <Slider
        name={name}
        value={+value || 0}
        onChange={(e, val) => !isDisabled && onChange?.(val)}
        min={min}
        max={max}
        step={step}
        marks={marks}
        valueLabelDisplay="on"
        disabled={isDisabled}
        sx={{
          color: getColor(),
          "& .MuiSlider-markLabel": { fontSize: "0.75rem", mt: 1 },
        }}
        {...rest}
      />
      {error && (
        <Typography variant="caption" color="error">
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default CustomSliderInput;
